import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Trash2, Radio, ShieldAlert } from "lucide-react";

export const useLiveStatus = () => {
  const [live, setLive] = useState({ banner_id: null, poster_ids: [] });
  const reload = () => api.get("/live-status").then(({ data }) => setLive(data)).catch(() => {});
  useEffect(() => { reload(); }, []);
  return { ...live, reload };
};

export const LiveBadge = ({ testId }) => (
  <span className="inline-flex items-center gap-1 rounded-md bg-red-600 px-2 py-0.5 text-[11px] font-bold uppercase tracking-wider text-white shadow-lg" data-testid={testId}>
    <Radio className="h-3 w-3 animate-pulse" /> En ligne
  </span>
);

const LiveWarning = ({ kind, name }) => (
  <div className="flex gap-3 rounded-lg border border-red-500/50 bg-red-500/10 p-3 text-sm text-red-400" data-testid="live-delete-warning">
    <ShieldAlert className="h-5 w-5 shrink-0" />
    <div>
      <p className="font-bold uppercase">{kind === "bandeau" ? "Ce bandeau est" : "Cette affiche est"} EN LIGNE sur l'écran TV</p>
      <p className="mt-1 text-red-300/90">
        « {name} » ne peut pas être supprimé{kind === "affiche" ? "e" : ""} tant qu'il est diffusé.{" "}
        {kind === "bandeau" ? "Choisissez d'abord un autre bandeau pour l'écran TV." : "Retirez-la d'abord du bandeau diffusé (ou utilisez « Remettre les matchs »)."}
      </p>
    </div>
  </div>
);

export const ProtectedDelete = ({ live, kind, name, onConfirm, triggerTestId, confirmTestId }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>
      <Button size="icon" variant="ghost" className="text-destructive hover:text-destructive" data-testid={triggerTestId}>
        <Trash2 className="h-4 w-4" />
      </Button>
    </AlertDialogTrigger>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>{live ? "Suppression impossible" : `Supprimer ${kind === "bandeau" ? "ce bandeau" : "cette affiche"} ?`}</AlertDialogTitle>
        <AlertDialogDescription asChild>
          {live ? <div><LiveWarning kind={kind} name={name} /></div> : <p>« {name} » sera définitivement supprimé{kind === "affiche" ? "e" : ""}. Cette action est irréversible.</p>}
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid={`${triggerTestId}-cancel`}>{live ? "Fermer" : "Annuler"}</AlertDialogCancel>
        {!live && (
          <AlertDialogAction onClick={onConfirm} className="bg-destructive text-destructive-foreground hover:bg-destructive/90" data-testid={confirmTestId}>
            Supprimer
          </AlertDialogAction>
        )}
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
